import { Mail, Phone, MapPin, MessageCircle, Building2 } from "lucide-react";
import MarketingShell from "@/components/marketing/MarketingShell";

export default function Contact() {
    return (
        <MarketingShell
            title="Contact & Support — Furmais"
            description="Need help with a project, onboarding, demo, or custom production workflow? Reach the Furmais team via email, phone, or WhatsApp."
            ogTitle="Contact Furmais"
            ogDescription="Talk to the team behind Furmais. WhatsApp for fastest response."
        >
            <section className="relative z-10 px-6 sm:px-10 pt-12 pb-24 max-w-3xl mx-auto" data-testid="contact-page">
                <div className="label-micro mb-3 text-[#FF4400]">Contact</div>
                <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-5">Contact &amp; Support</h1>
                <p className="text-zinc-300 text-base leading-relaxed mb-10">
                    Need help with a project, onboarding, demo, or custom production workflow?
                    Reach out to the Furmais team — we&apos;ll get back to you with the right
                    next step.
                </p>

                <div className="space-y-3 mb-10">
                    <ContactRow icon={Mail} label="Email">
                        <a href="mailto:support@furmais.com" data-testid="contact-email" className="text-white hover:text-[#FF4400]">
                            support@furmais.com
                        </a>
                    </ContactRow>
                    <ContactRow icon={Phone} label="Phone / WhatsApp">
                        <a href="tel:+918866065375" data-testid="contact-phone" className="text-white hover:text-[#FF4400]">
                            +91 88660 65375
                        </a>
                    </ContactRow>
                    <ContactRow icon={Building2} label="Company">
                        <span className="text-white">RIFA Productions</span>
                    </ContactRow>
                    <ContactRow icon={MapPin} label="Location">
                        <span className="text-white">Surat, Gujarat, India</span>
                    </ContactRow>
                </div>

                <div className="border border-amber-500/30 bg-amber-500/5 rounded-sm p-4 mb-8" data-testid="contact-support-note">
                    <p className="text-sm text-zinc-200 leading-relaxed">
                        <span className="text-amber-400 font-medium">Support note:</span>{" "}
                        For faster assistance, reach out via WhatsApp with your project details.
                    </p>
                </div>

                <a
                    href="https://wa.me/918866065375"
                    target="_blank"
                    rel="noreferrer"
                    data-testid="contact-whatsapp-cta"
                    className="btn-accent text-base inline-flex"
                >
                    <MessageCircle className="w-5 h-5" /> Chat on WhatsApp
                </a>
            </section>
        </MarketingShell>
    );
}

function ContactRow({ icon: Icon, label, children }) {
    return (
        <div className="flex items-start gap-4 border border-zinc-900 bg-[#080808] rounded-sm p-4">
            <Icon className="w-5 h-5 text-[#FF4400] shrink-0 mt-0.5" />
            <div className="flex-1">
                <div className="label-micro mb-1">{label}</div>
                <div className="text-base">{children}</div>
            </div>
        </div>
    );
}
